// Import the functions you need from the SDKs you need

import { initializeApp } from "firebase/app";
import {
  GoogleAuthProvider,
  createUserWithEmailAndPassword,
  getAuth,
  sendPasswordResetEmail,
  signInWithEmailAndPassword,
  signInWithPopup,
  signOut,
} from "firebase/auth";
import {
  addDoc,
  collection,
  getDocs,
  getFirestore,
  query,
  where,
} from "firebase/firestore";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const googleProvider = new GoogleAuthProvider();
// Function to save user authentication state in localStorage
const saveAuthState = (user) => {
  
  if (user) {
    localStorage.setItem('userLoggedIn', 'true');
  } else {
    localStorage.removeItem('userLoggedIn');
  }
};




// Check if the user was previously authenticated when the app loads
const checkAuthStateOnLoad = () => {
  const userLoggedIn = localStorage.getItem('userLoggedIn');
  if (userLoggedIn === 'true') {
    // User was previously authenticated, you can perform any necessary actions here
    return auth.currentUser; // Return the current user if logged in
  }
  return null; // Return null if not logged in
};

const signInWithGoogle = async () => {
  try {
    const res = await signInWithPopup(auth, googleProvider);
    const user = res.user;
    const q = query(collection(db, 'users'), where('uid', '==', user.uid));
    const docs = await getDocs(q);
    if (docs.docs.length === 0) {
      await addDoc(collection(db, 'users'), {
        uid: user.uid,
        name: user.displayName,
        authProvider: 'google',
        email: user.email,
      });
    }
    window.location.href = '/';
    saveAuthState(user); // Save user authentication state when they log in
    } catch (error){console.log("Error signing into Firebase:", error);}
  
};
// sign up with google
const signUpWithGoogle = async () => {
  try {
    const res = await signInWithPopup(auth, googleProvider);
    const user = res.user;
    const q = query(collection(db, 'users'), where('uid', '==', user.uid));
    const docs = await getDocs(q);
    if (docs.docs.length === 0) {
      await addDoc(collection(db, 'users'), {
        uid: user.uid,
        name: user.displayName,
        authProvider: 'google',
        email: user.email,
      });
    }
    window.location.href = '/';
    saveAuthState(user); // Save user authentication state when they log in
    } catch (error){console.log("Error signing into Firebase:", error);}
    }


const logInWithEmailAndPassword = async (email, password) => {
  try {
    await signInWithEmailAndPassword(auth, email, password);
    window.location.href = '/';
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};
const registerWithEmailAndPassword = async (displayName, email, password) => {
  try {
    const res = await createUserWithEmailAndPassword(auth, email, password);
    const user = res.user;
    await addDoc(collection(db, "users"), {
      uid: user.uid,
      displayName,
      authProvider: "local",
      email,
    });
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};

const sendPasswordReset = async (email) => {
  try {
    await sendPasswordResetEmail(auth, email);
    alert("Password reset link sent!");
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};
const logout = () => {
  signOut(auth);
  // navigate to login
};
// isAuthor take userid and authorid



// get currecnt user from local storage
const getCurrentUser = async () => {
  const user = localStorage.getItem('userLoggedIn');
  return user;
};



const isAuthor = (user, recipeAuthorUid) => {
  return user && user.uid === recipeAuthorUid;
};




export {
  auth, checkAuthStateOnLoad, db, getAuth, getCurrentUser, isAuthor, logInWithEmailAndPassword, logout, registerWithEmailAndPassword, saveAuthState, sendPasswordReset, signInWithGoogle, signOut,
  signUpWithGoogle
};
